export const MODES = {
  TEACHER: 'TEACHER',
  NORMAL: 'NORMAL',
};

export default {
  MODES,
};
